<template>
  <router-view />
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import invoiceStore from "@/modules/Invoice/store.js";

export default {
  name: "donor-index",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("invoice", invoiceStore);
  },
};
</script>
